import { motion } from "framer-motion";

/**
 * Animated, theme-aware duplicate-detection mockup: saving a URL that already
 * exists surfaces the existing bookmark before a copy is created.
 */

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.16, delayChildren: 0.2 } },
};
const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const softBadge = {
  background: "var(--mock-surface)",
  color: "var(--bs-secondary-color, var(--bs-secondary))",
  border: "1px solid var(--mock-border)",
};

export const DuplicateMock = ({ className = "" }) => {
  return (
    <motion.div
      className={`obm-mock obm-mock--duplicate ${className}`}
      variants={container}
      initial={false}
      animate="show"
    >
      <div className="obm-mock__chrome">
        <span className="obm-mock__dot" style={{ background: "#ef4444" }} />
        <span className="obm-mock__dot" style={{ background: "#f59e0b" }} />
        <span className="obm-mock__dot" style={{ background: "#10b981" }} />
        <div className="obm-mock__omnibox">
          <i className="bi bi-plus-circle me-1" />
          Save bookmark
        </div>
      </div>

      <div className="obm-mock__body">
        <motion.div
          variants={item}
          className="d-flex align-items-center rounded-3 px-3 py-2 mb-3"
          style={softBadge}
        >
          <i className="bi bi-link-45deg me-2" />
          <span className="text-truncate">react.dev/learn</span>
        </motion.div>

        <motion.div
          variants={item}
          className="small d-flex align-items-center mb-2 text-secondary"
        >
          <i className="bi bi-info-circle-fill me-2 text-info" />
          It looks like you already have this bookmark:
        </motion.div>

        <div className="obm-mock__list">
          <motion.div className="obm-mock__item" variants={item}>
            <span className="obm-mock__fav" style={{ background: "#047857" }}>
              R
            </span>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div className="text-truncate">React docs</div>
              <div className="small text-secondary text-truncate">
                react.dev/learn · saved 3 weeks ago
              </div>
            </div>
            <span className="badge" style={softBadge}>
              <i className="bi bi-folder me-1" />
              Frontend
            </span>
          </motion.div>
        </div>

        <motion.div
          variants={item}
          className="small text-secondary mt-3 d-flex align-items-center"
        >
          <i className="bi bi-magic me-2 text-purple" />
          Bulk imports skip duplicates automatically
        </motion.div>
      </div>
    </motion.div>
  );
};

export default DuplicateMock;
